export default __webpack_public_path__ + "static/media/06.41f531d9.jpg";